import DefaultDropButton from "../Buttons/DefaultDropButton/DefaultDropButton.js";
import {LuTrash2} from "react-icons/lu";
import React from "react";
import "./ReplaceFieldWithFunctionAction.css"

export function ReplaceFieldWithFunctionAction({
    index,
    fieldName,
    fieldNames,
    functionName,
    functionNames,
    onFieldChange,
    onValueChange,
    onDelete
}: {
    index: number;
    fieldName: string;
    fieldNames: string[];
    functionName: string;
    functionNames: string[];
    onFieldChange: (index: number, newValue: string) => void;
    onValueChange: (index: number, newValue: string) => void;
    onDelete: (index: number) => void;
}) {
    return <div className="action ReplaceFieldWithFunction" key={index}>
        <div className="firstText">Replace field</div>
        <DefaultDropButton
            name={"action_" + index + "_field"}
            options={fieldNames}
            onSelect={(v) => onFieldChange(index, v)}
            className="field"
            selected={fieldName}
            label={"Field to Replace"}
            hideLabel
            errorLoc={[]}
        />
        <div className="with">with fake data</div>
        <DefaultDropButton
            name={"action_" + index + "_function"}
            options={functionNames}
            onSelect={(v) => onValueChange(index, v)}
            className="function"
            selected={functionName}
            label={"Function"}
            hideLabel
            errorLoc={[]}
        />
        <div className="spacer" />
        <LuTrash2
            className="trash"
            onClick={() => onDelete(index)}
        />
    </div>
}